// extracted by mini-css-extract-plugin
export default {"contentContainer":"BlogDetail_contentContainer__+ojjn"};